(function () {
  /* Remove duplicate blocks pasted in Shopify page body (keep theme .espace-boutiques-page-wrap) */
  document.querySelectorAll('.shopify-section').forEach(function (section) {
    if (section.querySelector('.espace-boutiques-page-wrap')) return;
    var rte = section.querySelector('.rte');
    if (!rte) return;
    var text = rte.textContent || '';
    if (
      text.indexOf('Présence nationale') !== -1 ||
      text.indexOf('Qui sommes-nous') !== -1 ||
      text.indexOf('Une question') !== -1
    ) {
      section.remove();
    }
  });

  document.querySelectorAll('.hero, .info-banner').forEach(function (el) {
    if (el.closest('.espace-boutiques-page-wrap')) return;
    el.remove();
  });

  var stores = [
    { id: 1, weekday: [9, 20], sunday: [9, 20] },
    { id: 2, weekday: [7, 22], sunday: [7, 22] },
    { id: 3, weekday: [10, 19], sunday: null },
    { id: 4, weekday: [10, 20], sunday: [10, 20] },
    { id: 5, weekday: [9, 19], sunday: [10, 18] },
  ];

  var today = new Date().getDay();
  var nowH = new Date().getHours() + new Date().getMinutes() / 60;

  document.querySelectorAll('.espace-store-card__hours-row[data-days]').forEach(function (row) {
    var days = row.dataset.days.split(',').map(Number);
    if (days.includes(today)) row.classList.add('is-today');
  });

  stores.forEach(function (store) {
    var badge = document.getElementById('espace-store-badge-' + store.id);
    if (!badge) return;
    var sch = today === 0 ? store.sunday : store.weekday;
    var open = false;
    if (sch) open = nowH >= sch[0] && nowH < sch[1];
    badge.textContent = open ? 'Ouvert' : 'Fermé';
    badge.classList.toggle('is-open', open);
    badge.classList.toggle('is-closed', !open);
  });

  function equalizeCardSections(selector) {
    var cards = document.querySelectorAll('.espace-store-card');
    if (!cards.length) return;
    var maxH = 0;
    cards.forEach(function (card) {
      var block = card.querySelector(selector);
      if (block) maxH = Math.max(maxH, block.offsetHeight);
    });
    if (maxH > 0) {
      cards.forEach(function (card) {
        var block = card.querySelector(selector);
        if (block) block.style.minHeight = maxH + 'px';
      });
    }
  }

  equalizeCardSections('.espace-store-card__top');
  equalizeCardSections('.espace-store-card__img');

  function initAutoScroll() {
    var grid = document.querySelector('.espace-stores-grid');
    if (!grid) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var pause = false;
    var isManualInteracting = false;
    var resumeTimer = null;
    var raf = null;
    var speed = 0.9; // px per frame

    if (!grid.dataset.clonedForLoop) {
      var originalCards = Array.prototype.slice.call(grid.children);
      originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        grid.appendChild(clone);
      });
      grid.dataset.clonedForLoop = 'true';
    }

    function canScroll() {
      return grid.scrollWidth > grid.clientWidth + 8;
    }

    function getLoopWidth() {
      return grid.scrollWidth / 2;
    }

    function step() {
      if (!pause && !isManualInteracting && canScroll()) {
        var next = grid.scrollLeft + speed;
        var loopWidth = getLoopWidth();
        if (next >= loopWidth) {
          next = next - loopWidth;
        }
        grid.scrollLeft = next;
      }

      raf = window.requestAnimationFrame(step);
    }

    function pauseForManualInteraction() {
      isManualInteracting = true;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        isManualInteracting = false;
      }, 900);
    }

    function start() {
      if (raf) return;
      grid.classList.add('is-auto-scrolling');
      raf = window.requestAnimationFrame(step);
    }

    function stop() {
      if (!raf) return;
      window.cancelAnimationFrame(raf);
      raf = null;
      grid.classList.remove('is-auto-scrolling');
    }

    grid.addEventListener('touchstart', function () {
      pause = true;
    }, { passive: true });
    grid.addEventListener('touchend', function () {
      pause = false;
      pauseForManualInteraction();
    }, { passive: true });
    grid.addEventListener('wheel', pauseForManualInteraction, { passive: true });
    grid.addEventListener('pointerdown', pauseForManualInteraction, { passive: true });

    window.addEventListener('resize', function () {
      if (!canScroll()) {
        grid.scrollLeft = 0;
      } else {
        var loopWidth = getLoopWidth();
        if (grid.scrollLeft >= loopWidth) {
          grid.scrollLeft = grid.scrollLeft - loopWidth;
        }
      }
    });

    if (canScroll()) start();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else if (canScroll()) {
        start();
      }
    });
  }

  initAutoScroll();
})();
